import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getKnmRegistryData = (state: IRootState) => state.knmRegistry.data;
